<div>
  <img src="assets/img/logo.svg" alt="Generali Italia" />
  <div class="text-container">
    <h1>SESSIONE CONCLUSA</h1>
    <h3>Si verr&agrave; reindirizzati alla pagina di login</h3>
    <mat-progress-bar mode="indeterminate" class="mt-8"></mat-progress-bar>
  </div>
</div>
